var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHolidayVillage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.192497 15.4999V6.21143L5.69225 0.711426L11.1922 6.21143V15.4999H0.192497ZM1.69225 13.9999H4.80775V11.3462H6.577V13.9999H9.69225V6.82493L5.69225 2.82493L1.69225 6.82493V13.9999ZM4.80775 8.88443V7.11543H6.577V8.88443H4.80775ZM13 15.5094V5.46342L8.248 0.711426H10.3712L14.5 4.84043V15.5094H13ZM16.3077 15.5094V4.09218L12.927 0.711426H15.0595L17.8075 3.46918V15.5094H16.3077Z",
    fill: "#9CB8A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayVillage);
export default __webpack_public_path__ + "static/media/holiday_village.c9117a36a3ee9f4ef9b8ef6beb3884f2.svg";
export { ForwardRef as ReactComponent };